import { promoRequest, promoResponse } from "../../types/rtk/promo/promo";
import { apiSlice } from "../_api/api-slice";

const promoEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    postPromo: build.query<promoResponse, {body: promoRequest}>({
      query: ({body}) => ({
        url: `/promo-code/validate`,
        method: "post",
        body
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyPostPromoQuery
} = promoEndpoint;